module.exports = __webpack_public_path__ + "static/media/point_yellow_select.1ea016b0.svg";